<template>
  <div>
    <ResetPassword @quit="quit" v-if="showResetPassword" />
    <a-list itemLayout="horizontal">
      <a-list-item>
        <a-button type="primary" slot="actions" @click="setPassword">{{$t('global.modify')}}</a-button>
        <a-list-item-meta>
          <div slot="title" >{{$t('setting.resetPassword')}}</div>
        </a-list-item-meta>
      </a-list-item>

      <!-- <a-list-item>
        <a-radio-group size="small" v-model="noticeType" @change="changedNoticeType" defaultValue="2" buttonStyle="solid">
          <template v-for="(item, index) in noticeTypes">
            <a-radio-button :key="index" :value="item.value">{{item.text}}</a-radio-button>
          </template>
        </a-radio-group>
        <a-list-item-meta description="告警重复提醒">
          <div slot="title">选择重复告警铃声提醒</div>
        </a-list-item-meta>
      </a-list-item> -->
    </a-list>
  </div>
</template>

<script>
import ResetPassword from '../../components/common/ResetPassword'
import {httpModel} from '../../http/httpModel'
import {mapActions, mapState} from 'vuex'
  export default {
    name: 'SecuritySetting',
    components: {
      ResetPassword
    },
    data() {
      return {
        showResetPassword: false,
        isRepeat: false,
        noticeTypes: [
          {text: '响一声', value: '2'},
          {text: '不响', value: '1'},
          {text: '一直响', value: '3'},
        ],
        noticeType: '2'
      }
    },
    computed: {
      ...mapState(['alarmNoticeType']),
    },
    methods: {
      // action () {}
      ...mapActions(['setAlarmNoticeType']),
      changedNoticeType () {
        // console.log(e)
        // console.log(this.noticeType)
        httpModel.setAlarmRingType(this.noticeType).then((res) => {
          // console.log(res)
          this.setAlarmNoticeType(res)
          this.$notification.success({
            message: this.$t('global.commitSuccess')
          })
        })
      },
      setPassword () {
        // console.log(1)
        this.showResetPassword = true
      },
      quit () {
        this.showResetPassword = false
      },
      setAlarmRepeat (e) {
        // console.log(e)
        localStorage.setItem('isRepeatAlarm', e)
      },
      formatBool () {
        let isRepeatAlarm = localStorage.getItem('isRepeatAlarm')
        if (isRepeatAlarm && isRepeatAlarm === 'true') {
          return true
        } else {
          return false
        }
      }
    },
    created () {
      this.isRepeat = this.formatBool()
      this.noticeType = this.alarmNoticeType
    }
  }
</script>